export default "__VITE_ASSET__DC3jEQTi__"